import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpDeleteFollowUp} from './treatment-requests.http'
import {MUTATION_KEYS} from '@/queryClient'

export const useDeleteFollowUp = (followUpId: string, options?: Omit<UseMutationOptions, 'mutationFn'>) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_FOLLOW_UP],
        mutationFn: () => httpDeleteFollowUp({urlParams: {followUpId}}),
        ...options
    })
